import { DayOpeningHour } from './dayopeninghour';

export class DeadlinesForProduct {
  public productTypeName: string;
  public daysOpeningHours: DayOpeningHour[];
  public daysOpeningHoursSeperated: DayOpeningHour[];
}
